import React, { Component } from "react";
import Quiz from "./components/quiz";
import "./css/app.css";

class App extends Component {
  render() {
    return (
      <main className="container">
        <Quiz />
      </main>
    );
  }
}

export default App;
